import { createFileRoute } from "@tanstack/react-router";
import { RunHistory } from "@/components/views/run/RunHistory";

export const Route = createFileRoute("/runs/")({
  component: RunHistory,
});
